import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useStyles } from './OffersComponent.styles'
import { useTheme } from '@mui/material/styles'
import { TotalAndPercentage } from '../TotalAndPercentage/TotalAndPercentage'
import { CustomLegends } from '../CustomLegends/CustomLegends'
import { LineChartComponent } from '../../../common/components/LineChartComponent/LineChartComponent'
import { Typography } from '@mui/material'
import { Overview } from '../../../modules/flyoutOverview/types'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import { numberFormat } from '@labrav/common'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'
import { isEmpty } from 'lodash'

interface Props {
  offersForBuyers: Overview['offersForBuyers']
  currency?: string
  link?: string
}
export const OffersForBuyers: React.FC<Props> = ({
  offersForBuyers,
  currency = '',
  link = '',
}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(link)
  }

  const awsCount = offersForBuyers?.data?.aws?.count
  const microsoftCount = offersForBuyers?.data?.microsoft?.count
  const gcpCount = offersForBuyers?.data?.gcp?.count

  const offersForBuyersList = {
    aws: offersForBuyers?.data?.aws,
    microsoft: offersForBuyers?.data?.microsoft,
    gcp: offersForBuyers?.data?.gcp,
  }

  const isOffersForBuyersDataEmpty =
    !offersForBuyers?.data ||
    Object.values(offersForBuyers.data).every(
      offer =>
        (offer.count === 0 || offer.count === null) &&
        (offer.percentage === 0 || offer.percentage === null)
    )

  return (
    <>
      {isOffersForBuyersDataEmpty ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={20.5}
          imageHeight={12}
          imageWidth={16.75}
          description="It's time to create your first offer."
          button={
            <div
              className={classes.viewEmptyDetailsContainer}
              data-testid="buyers-view-details"
            >
              <Typography
                className={classes.viewDetailsText}
                onClick={handleClick}
              >
                View details
              </Typography>
            </div>
          }
        />
      ) : (
        <div
          data-testid={'offers-for-buyers-component'}
          className={classes.root}
        >
          <TotalAndPercentage
            total={offersForBuyers?.total}
            percentage={offersForBuyers?.percentage}
            type={offersForBuyers?.rise}
            currency={currency}
          />
          <div
            className={classes.lineChartComponent}
            data-testid={'buyers-line-chart'}
          >
            <LineChartComponent
              classes={classes}
              data={offersForBuyersList}
              colors={[
                theme.palette.awsGraph.main,
                theme.palette.microsoftGraph.main,
                theme.palette.gcpGraph.main,
              ]}
            />
            <div
              className={classes.legendsWrapper}
              data-testid={'buyers-custom-legend-wrapper'}
            >
              <CustomLegends
                legends={[
                  {
                    label: 'AWS:',
                    legendColor: theme.palette.awsGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(awsCount || 0)),
                  },
                  {
                    label: 'Microsoft:',
                    legendColor: theme.palette.microsoftGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(microsoftCount || 0)),
                  },
                  {
                    label: 'GCP:',
                    legendColor: theme.palette.gcpGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(gcpCount || 0)),
                  },
                ]}
              />
            </div>
          </div>
          {!isEmpty(link) && (
            <div
              className={classes.viewDetailsContainer}
              data-testid="buyers-view-details"
            >
              <Typography
                className={classes.viewDetailsText}
                onClick={handleClick}
              >
                View details
              </Typography>
            </div>
          )}
        </div>
      )}
    </>
  )
}
